import { Directive, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { ModalService } from '../../modals/services/modal.service';
import { QuickAdditModal } from '../modals/quick-addit.modal';
import { Model } from '../../api/model';
import { ToastService } from '../../toast/services/toast.service';

@Directive({
    selector: '[quickAddit]'
})
export class QuickAdditDirective implements OnInit {

    @Input() public entity;

    @Input('entityId') public entityId;

    @Output('onAddit') public onAddit: EventEmitter<any> = new EventEmitter();

    constructor(protected modalService: ModalService, protected toastService: ToastService) {
        console.warn('quick addit directive');
    }

    public ngOnInit(): void {

        console.log('init quickAddit directive', this.entity, this.entityId);

    }

    @HostListener('click')
    public onClick() {

        const modal = this.modalService.open(QuickAdditModal, {entity: this.entity, entityId: this.entityId});

        modal.result.then((result) => {

            this.onAddit.emit(result.model);

        }, (reason) => {

        });

    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/quick-addit/directives/quick-addit.directive.ts